﻿function project(components) {
    VeeValidate.extend('NotEqual', {
        validate(value, args) {
            return value != args.empty;
        },
        params: ['empty'],
        message: 'The {_field_} field is required.',
        computesRequired: true
    });
}

module.exports = project;

